import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "home-console" }
const _hoisted_2 = { class: "empty-block" }
const _hoisted_3 = { class: "resource-list" }
const _hoisted_4 = { class: "resource-item blue" }
const _hoisted_5 = { class: "resource-item blue" }
const _hoisted_6 = { class: "resource-item blue" }
const _hoisted_7 = { class: "resource-item blue" }
const _hoisted_8 = { class: "resource-item blue" }
const _hoisted_9 = { class: "resource-item blue" }
const _hoisted_10 = { class: "resource-item orange" }
const _hoisted_11 = { class: "resource-item orange" }
const _hoisted_12 = { class: "resource-item blue" }
const _hoisted_13 = { style: {"text-align":"right","margin-top":"16px"} }
const _hoisted_14 = { class: "empty-block" }
const _hoisted_15 = { class: "empty-block" }
const _hoisted_16 = { class: "empty-block" }
const _hoisted_17 = { class: "help-list" }
const _hoisted_18 = { class: "user-block" }
const _hoisted_19 = { class: "user-info" }
const _hoisted_20 = { style: {"font-weight":"bold","font-size":"16px"} }
const _hoisted_21 = { style: {"color":"#888","font-size":"13px"} }
const _hoisted_22 = { style: {"color":"#1890ff","font-size":"13px"} }
const _hoisted_23 = { class: "empty-block" }

import { ref } from 'vue'
import { UserOutlined } from '@ant-design/icons-vue'

export default /*@__PURE__*/_defineComponent({
  __name: 'HomeConsole',
  setup(__props) {

const tabKey = ref('iot')

return (_ctx: any,_cache: any) => {
  const _component_a_empty = _resolveComponent("a-empty")!
  const _component_a_card = _resolveComponent("a-card")!
  const _component_a_icon = _resolveComponent("a-icon")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_tab_pane = _resolveComponent("a-tab-pane")!
  const _component_a_tabs = _resolveComponent("a-tabs")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_avatar = _resolveComponent("a-avatar")!
  const _component_a_row = _resolveComponent("a-row")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_a_row, { gutter: 16 }, {
      default: _withCtx(() => [
        _createVNode(_component_a_col, { span: 16 }, {
          default: _withCtx(() => [
            _createVNode(_component_a_card, {
              title: "最近访问",
              class: "mb16"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_2, [
                  _createVNode(_component_a_empty, { description: "暂无访问记录~" }, {
                    image: _withCtx(() => _cache[1] || (_cache[1] = [
                      _createElementVNode("img", {
                        src: "https://img.icons8.com/ios/100/000000/opened-folder.png",
                        style: {"width":"80px","opacity":"0.3"}
                      }, null, -1)
                    ])),
                    _: 1
                  })
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_a_card, {
              title: "我的资源",
              class: "mb16"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_tabs, {
                  activeKey: tabKey.value,
                  "onUpdate:activeKey": _cache[0] || (_cache[0] = ($event: any) => ((tabKey).value = $event))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_tab_pane, {
                      key: "iot",
                      tab: "智联网"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_3, [
                          _createElementVNode("div", _hoisted_4, [
                            _createVNode(_component_a_icon, { type: "appstore" }),
                            _cache[2] || (_cache[2] = _createTextVNode(" 智联网概况 "))
                          ]),
                          _createElementVNode("div", _hoisted_5, [
                            _createVNode(_component_a_icon, { type: "database" }),
                            _cache[3] || (_cache[3] = _createTextVNode(" 设备管理 "))
                          ]),
                          _createElementVNode("div", _hoisted_6, [
                            _createVNode(_component_a_icon, { type: "branches" }),
                            _cache[4] || (_cache[4] = _createTextVNode(" 协议网关 "))
                          ]),
                          _createElementVNode("div", _hoisted_7, [
                            _createVNode(_component_a_icon, { type: "file-protect" }),
                            _cache[5] || (_cache[5] = _createTextVNode(" 协议脚本 "))
                          ]),
                          _createElementVNode("div", _hoisted_8, [
                            _createVNode(_component_a_icon, { type: "info-circle" }),
                            _cache[6] || (_cache[6] = _createTextVNode(" 设备详情 "))
                          ]),
                          _createElementVNode("div", _hoisted_9, [
                            _createVNode(_component_a_icon, { type: "cloud-upload" }),
                            _cache[7] || (_cache[7] = _createTextVNode(" ota升级 "))
                          ]),
                          _createElementVNode("div", _hoisted_10, [
                            _createVNode(_component_a_icon, { type: "appstore" }),
                            _cache[8] || (_cache[8] = _createTextVNode(" 通用物模型 "))
                          ]),
                          _createElementVNode("div", _hoisted_11, [
                            _createVNode(_component_a_icon, { type: "appstore" }),
                            _cache[9] || (_cache[9] = _createTextVNode(" 产品管理 "))
                          ]),
                          _createElementVNode("div", _hoisted_12, [
                            _createVNode(_component_a_icon, { type: "appstore" }),
                            _cache[10] || (_cache[10] = _createTextVNode(" 产品品类 "))
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_13, [
                          _createVNode(_component_a_button, { type: "primary" }, {
                            default: _withCtx(() => _cache[11] || (_cache[11] = [
                              _createTextVNode("进入模块")
                            ])),
                            _: 1
                          })
                        ])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_tab_pane, {
                      key: "sys",
                      tab: "系统管理"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_14, [
                          _createVNode(_component_a_empty, { description: "暂无内容" })
                        ])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_tab_pane, {
                      key: "code",
                      tab: "低代码"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_15, [
                          _createVNode(_component_a_empty, { description: "暂无内容" })
                        ])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_tab_pane, {
                      key: "my",
                      tab: "我的物联"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_16, [
                          _createVNode(_component_a_empty, { description: "暂无内容" })
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["activeKey"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_card, { title: "帮助文档" }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_17, [
                  _createVNode(_component_a_button, {
                    type: "default",
                    icon: "file-text",
                    class: "help-btn"
                  }, {
                    default: _withCtx(() => _cache[12] || (_cache[12] = [
                      _createTextVNode("官方文档")
                    ])),
                    _: 1
                  }),
                  _createVNode(_component_a_button, {
                    type: "default",
                    icon: "link",
                    class: "help-btn"
                  }, {
                    default: _withCtx(() => _cache[13] || (_cache[13] = [
                      _createTextVNode("开源地址")
                    ])),
                    _: 1
                  })
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_a_col, { span: 8 }, {
          default: _withCtx(() => [
            _createVNode(_component_a_card, null, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_18, [
                  _createVNode(_component_a_avatar, {
                    size: "large",
                    style: {"background":"#e6f7ff","color":"#1890ff"}
                  }, {
                    icon: _withCtx(() => [
                      _createVNode(_unref(UserOutlined))
                    ]),
                    _: 1
                  }),
                  _createElementVNode("div", _hoisted_19, [
                    _createElementVNode("div", _hoisted_20, [
                      _cache[14] || (_cache[14] = _createTextVNode("administrator ")),
                      _createVNode(_component_a_icon, {
                        type: "copy",
                        style: {"margin-left":"4px"}
                      })
                    ]),
                    _createElementVNode("div", _hoisted_21, [
                      _cache[15] || (_cache[15] = _createTextVNode("账号ID: 174035805703188544 ")),
                      _createVNode(_component_a_icon, {
                        type: "copy",
                        style: {"margin-left":"4px"}
                      })
                    ]),
                    _createElementVNode("a", _hoisted_22, [
                      _cache[16] || (_cache[16] = _createTextVNode("查看详情 ")),
                      _createVNode(_component_a_icon, { type: "right" })
                    ])
                  ])
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_a_card, { style: {"margin-top":"16px"} }, {
              default: _withCtx(() => [
                _createVNode(_component_a_tabs, { "default-active-key": "all" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_tab_pane, {
                      key: "all",
                      tab: "全部消息"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_23, [
                          _createVNode(_component_a_empty, { description: "暂无数据" })
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _cache[17] || (_cache[17] = _createElementVNode("div", { class: "footer" }, "Powered by 迈睿达 Copyright 湖北迈睿达供应链股份有限公司", -1))
  ]))
}
}

})